import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useState, useCallback } from 'react';
import { emptyFunc } from '../../../../../helpers/common';
import { propArrayShape, propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import DirectoryIcon from '../../../../Icon/Svg/DirectoryIcon';
import SubmitButton from '../../../../Ui/Button/SubmitButton';
const ActionSaveBody = (props) => {
    const { className, folders, loading, onClickSave: rawOnClickSave } = props;
    const [loadingId, changeLoadingId] = useState(null);
    const onClickSave = useCallback((e) => {
        const value = e.currentTarget.getAttribute('data-value');
        changeLoadingId(value);
        rawOnClickSave(value);
    }, [rawOnClickSave, changeLoadingId]);
    if (folders.length === 0) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: className }, { children: _jsx("ul", { children: folders.map((v) => (_jsxs("li", Object.assign({ className: clsx('action_save_row', loading && loadingId !== v.id && 'hide-button is-disabled', loading && loadingId === v.id && 'show-button'), "data-value": v.id, onClick: loading ? undefined : onClickSave, role: 'presentation' }, { children: [_jsx(DirectoryIcon, {}), _jsx("span", Object.assign({ className: 'action_save_label' }, { children: v.name })), _jsx(SubmitButton, { buttonType: 'button', className: 'action_save_button', isDisabled: loading, isLoading: loading, onClick: emptyFunc, text: '保存' })] }), v.id))) }) })));
};
ActionSaveBody.propTypes = {
    className: propStr().isRequired,
    folders: propArrayShape().isRequired,
    loading: propBool().isRequired,
    onClickSave: propFunc().isRequired,
};
export default ActionSaveBody;
